export const categories = [
  { id: "shoes", name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", imageSeq: "cat-shoes" },
  { id: "hoodies", name: "Hoodies / Sweaters", url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html", imageSeq: "cat-hoodies" },
  { id: "tshirts", name: "T-Shirts", url: "https://kaspreadsheet.com/category-913-T-Shirts.html", imageSeq: "cat-tshirts" },
  { id: "jackets", name: "Jackets", url: "https://kaspreadsheet.com/category-914-Jackets.html", imageSeq: "cat-jackets" },
  { id: "pants", name: "Pants / Shorts", url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html", imageSeq: "cat-pants" },
  { id: "headwear", name: "Headwear", url: "https://kaspreadsheet.com/category-916-Headwear.html", imageSeq: "cat-headwear" },
  { id: "sets", name: "Sets", url: "https://kaspreadsheet.com/category-917-Sets.html", imageSeq: "cat-sets" },
  { id: "underwear", name: "Underwear / Underpants", url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html", imageSeq: "cat-underwear" },
  { id: "jersey", name: "Jersey", url: "https://kaspreadsheet.com/category-919-Jersey.html", imageSeq: "cat-jersey" },
  { id: "accessories", name: "Accessories", url: "https://kaspreadsheet.com/category-920-Accessories.html", imageSeq: "cat-accessories" },
  { id: "bags", name: "Bags", url: "https://kaspreadsheet.com/category-921-Bags.html", imageSeq: "cat-bags" },
  { id: "belts", name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Bags.html", imageSeq: "cat-belts" },
  { id: "perfumes", name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Bags.html", imageSeq: "cat-perfumes" },
  { id: "otherstuff", name: "OtherStuff", url: "https://kaspreadsheet.com/search-924/name/Bags.html", imageSeq: "cat-otherstuff" },
];

export const features = [
  {
    id: "automation",
    title: "Automatisation avancée",
    description: "Le hipobuy spreadsheet automatise le suivi des produits e-commerce, éliminant les tâches manuelles répétitives.",
    imageSeq: "feat-automation",
  },
  {
    id: "analysis",
    title: "Analyse concurrentielle",
    description: "Analysez les prix et les performances de vos concurrents en temps réel avec des données précises.",
    imageSeq: "feat-analysis",
  },
  {
    id: "scalability",
    title: "Scalabilité maximale",
    description: "Développez votre business e-commerce sans limite grâce à un système de suivi produit évolutif.",
    imageSeq: "feat-scalability",
  },
];

export const comparisonData = [
  { feature: "Automatisation", excel: "❌", hipobuy: "✅ avancé" },
  { feature: "Analyse produit", excel: "❌", hipobuy: "✅ puissant" },
  { feature: "Suivi prix", excel: "❌", hipobuy: "✅ temps réel" },
  { feature: "Scalabilité", excel: "faible", hipobuy: "élevé" },
];